import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const resourceSelector = ({ resource }: ReducerState) => resource;
export const resourceLoadingSelector = createSelector(
  resourceSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
